import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { preloadListAssets, preloadListAssetTags } from '@/api/react-query'
import { AssetLibraryPage } from '@/components/asset-library-page'
import { DEFAULT_PAGE_SIZE } from '@/components/table/pagination'
import { useI18n } from '@/i18n/i18n-react'

const LibrarySearchSchema = z.object({
	limit: z.coerce.number().min(1).max(100).default(DEFAULT_PAGE_SIZE),
	offset: z.coerce.number().default(0),
	q: z.string().optional(),
	tags: z.array(z.string()).optional(),
	channels: z.array(z.string()).optional(),
	content: z.array(z.string()).optional(),
	view: z.enum(['table', 'gallery']).default('table')
})

export const Route = createFileRoute('/_authenticated/_general/marketing/library')({
	component: MarketingLibraryPage,
	validateSearch: LibrarySearchSchema,
	loaderDeps: ({ search: { limit, offset, q, tags, channels, content } }) => ({
		limit,
		offset,
		q,
		tags,
		channels,
		content
	}),
	loader: async ({ context, deps: { limit, offset, q, tags, channels, content } }) => {
		await Promise.all([
			preloadListAssets(context, {
				query: {
					category: ['MARKETING'],
					q,
					tags: tags?.length ? tags : undefined,
					channelUuids: channels?.length ? channels : undefined,
					contentUuids: content?.length ? content : undefined,
					limit,
					offset
				}
			}),
			preloadListAssetTags(context, { query: { category: 'MARKETING' } })
		])
	},
	staticData: {
		crumb: ({ context: { L } }) => L.Marketing.Library()
	}
})

function MarketingLibraryPage() {
	const { L } = useI18n()
	return <AssetLibraryPage category='MARKETING' heading={L.Marketing.Library()} copy={L.Marketing.LibraryPage} />
}
